import { Link } from "react-router-dom";
import { ScrollSection } from "@/components/main-page/ScrollSection";
import {
  PRODUCTS,
  GHOST_AGENTS,
  GHOST_VISUALS,
  BrowserChrome,
  FormMockup,
  ChatMockup,
  FinanceMockup,
} from "@/components/products/shared";

export function ProductsSection() {
  return (
    <ScrollSection id="products" title="What we're building">
      <div
        className="grid md:grid-cols-3 gap-6 md:[mask-image:linear-gradient(to_bottom,black_0%,black_55%,transparent_95%)] md:[-webkit-mask-image:linear-gradient(to_bottom,black_0%,black_55%,transparent_95%)]"
      >
        {PRODUCTS.map((product) => (
          <div key={product.name} className="border border-[var(--color-border)] bg-[var(--color-surface)] flex flex-col overflow-hidden">
            <div className="p-6 md:p-8 flex flex-col flex-1">
              <BrowserChrome>
                {product.mockup === "form" && <FormMockup />}
                {product.mockup === "chat" && <ChatMockup />}
                {product.mockup === "finance" && <FinanceMockup />}
              </BrowserChrome>
              <div className="flex items-center gap-2 mb-2">
                <h3 className="text-lg font-medium">{product.name}</h3>
                <span className={`text-[10px] font-[family-name:var(--font-mono)] tracking-widest uppercase px-2 py-0.5 rounded ${product.badgeColor}`}>
                  {product.badge}
                </span>
              </div>
              <p className="text-sm text-[var(--color-fg-secondary)] leading-relaxed mb-3">{product.description}</p>
              <div className="mt-auto pt-4 border-t border-[var(--color-border)] flex items-center justify-between">
                <span className="text-[10px] font-[family-name:var(--font-mono)] tracking-widest text-[var(--color-fg-tertiary)]">{product.categoryTag}</span>
                {product.link ? (
                  <a href={product.link} target="_blank" rel="noopener noreferrer" className="text-xs font-[family-name:var(--font-mono)] text-[var(--color-fg-secondary)] hover:text-[var(--color-fg)] transition-colors">
                    xeni.legal →
                  </a>
                ) : (
                  <Link
                    to={`/products#${product.name === "Robolab X" ? "robolabx" : "metaroom"}`}
                    className="text-xs font-[family-name:var(--font-mono)] text-[var(--color-fg-secondary)] hover:text-[var(--color-fg)] transition-colors"
                  >
                    Learn more →
                  </Link>
                )}
              </div>
            </div>
          </div>
        ))}

        {GHOST_AGENTS.map((ghost, i) => {
          const Visual = GHOST_VISUALS[i]!;
          return (
          <div key={ghost.name} className="hidden md:flex border border-[var(--color-border)] bg-[var(--color-surface)] flex-col overflow-hidden">
            <div className="p-6 md:p-8 flex flex-col flex-1">
              <Visual />
              <div className="flex items-center gap-2 mb-2">
                <h3 className="text-lg font-medium">{ghost.name}</h3>
              </div>
              <div className="mt-auto pt-4 border-t border-[var(--color-border)]">
                <span className="text-[10px] font-[family-name:var(--font-mono)] tracking-widest text-[var(--color-fg-tertiary)]">{ghost.tag}</span>
              </div>
            </div>
          </div>
          );
        })}
      </div>
    </ScrollSection>
  );
}
